module.exports = __webpack_public_path__ + "static/media/REVIcon_MiniSet.2b015965.png";